import React, { useState } from "react";
import { Input} from "reactstrap";

// scanMode: cuando esta activo, si ya hay un ObjectId completo (24 chars) en el
// buscador y llega mas texto pegado (segundo escaneo del QR), se descarta el
// anterior y se queda solo con el codigo nuevo.
const Search = ({ onSearch, scanMode = false }) => {
    const [search, setSearch] = useState("");

    const onInputChange = value => {
        let nuevo = value;

        if (scanMode && search.length >= 24 && value.length > search.length && value.startsWith(search)) {
            nuevo = value.slice(search.length);
        }

        setSearch(nuevo);
        onSearch(nuevo);
    };
    return (
        <Input
            bsSize="sm"
            type="text"
            // className="form-control"
            style={{ width: "240px" }}
            placeholder="Search"
            value={search}
            onChange={e => onInputChange(e.target.value)}
        />
    );
};

export default Search;
